import { render } from "./BaseDataTableEditableField.vue?vue&type=template&id=4f646edd&scoped=true"
import script from "./BaseDataTableEditableField.vue?vue&type=script&lang=js"
export * from "./BaseDataTableEditableField.vue?vue&type=script&lang=js"

import "./BaseDataTableEditableField.vue?vue&type=style&index=0&id=4f646edd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f646edd"]])

export default __exports__